import {
    LIST_PAYMENT_LOTS,
    LIST_PAYMENT_LOTS_SUCCESS,
    LIST_PAYMENT_LOTS_ERROR,
    BRANCH_PAYMENT_LOT,
    BRANCH_PAYMENT_LOT_SUCCESS,
    BRANCH_PAYMENT_LOT_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    paymentLots: null,
    error: null,
    loading: false,
    loadingPayment: false,
    message: null,
    paidoutLot: null
}

export default function paymentLotsReducer(state = initialState, action) {
    switch(action.type){
        case LIST_PAYMENT_LOTS:
            return {
                ...state,
                loading: true
            }
        case LIST_PAYMENT_LOTS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_PAYMENT_LOTS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                paymentLots: action.payload
            }
        case BRANCH_PAYMENT_LOT:
            return {
                ...state,
                loadingPayment: true,
                message: null
            }
        case BRANCH_PAYMENT_LOT_ERROR:
            return {
                ...state,
                loadingPayment: false,
                error: action.payload,
                message: null
            }
        case BRANCH_PAYMENT_LOT_SUCCESS:
            return {
                ...state,
                error: null,
                paymentLots: state.paymentLots.filter(element => element.id !== action.payload.id),
                message: `La ORDEN DE PAGO (${action.payload.identificator}) fue generada correctamente, debe dirigirse a una sucursal del ${process.env.REACT_APP_BANK} para realizar el pago correspondiente.`,
                paidoutLot: action.payload
            }
        default:
            return state;
    }
}